import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"id":"city-get"}},[_c('sala-municipio-header',{attrs:{"payload":_vm.payload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }